import axios from 'axios';
import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Alert, Button, Card, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import {Spinner} from "react-bootstrap";

class LoginComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            email: this.props.emailSave ? this.props.emailSave : '',
            password: this.props.passwordSave ? this.props.passwordSave : '',
            remember: false,
            error: false,
            messageError: '',
            btnDisable: false,
            successNotification: false,
            messageSuccessNotification: '',
            errorNotification: false,
            messageErrorNotification: '',
        };
        this.changeInput = this.changeInput.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.setState({
            errorNotification: this.props.errorNotificationUser,
            messageErrorNotification: this.props.messageErrorNotificationUser,
            successNotification: this.props.successNotificationUser,
            messageSuccessNotification: this.props.messageSuccessNotificationUser,
        })
        // console.log(this.props.errorNotificationUser);
        // console.log(this.props.successNotificationUser);
        if (this.props.errorNotificationUser) {
            this.props.updateErrorNotiUser({
                error: false,
                message: ''
            });
        }
        if (this.props.successNotificationUser) {
            this.props.updateSuccessNotiUser({
                success: false,
                message: ''
            });
        }
    }


    submitLogin = () => {
        // console.log( this.state.email + ' - ' + this.state.password + ' - ' + this.state.remember  );
        this.setState({
            btnDisable: true
        })
        let validate = this.validate();
        if ( validate ) {
            let item = {
                'email': this.state.email,
                'password': this.state.password,
            };
            if ( this.state.remember ) {
                this.props.remember(item);
            }
            this.setState({
                isLoading: true
            });

            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };

            axios.post( process.env.REACT_APP_API_URL + '/api/login', item,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( async (ref) =>  {
                    if ( ref.data.error === 0 ) {
                        // console.log(ref.data);
                        let itemLogin = {
                            token: ref.data.token,
                            is2Fa: ref.data.is2Fa,
                        }
                        this.props.login(itemLogin);
                        let menu = 'user';
                        let sessionRole = 'user';
                        if ( ref.data.user.role === 'admin' || ref.data.user.role === 'super_admin' ) {
                            menu = 'cloudzoneAdmin-admin-menuAdmin';
                            sessionRole = 'cloudzoneAdmin-admin-admin';

                            let itemAgency = {
                                agency_credit: ref.data.timeC
                            }
                            await this.props.updateAgencyCredit(itemAgency);
                        }
                        else {
                            this.props.updatePageAdmin({ isMenuAdmin: false });
                        }

                        let itemUser = {
                            user: ref.data.user,
                            menu: menu,
                            sessionRole: sessionRole,
                            credit: ref.data.credit,
                        }

                        await this.props.saveUser(itemUser);

                        await this.setState({
                            isLoading: false
                        });

                        if ( !ref.data.is2Fa ) {
                            this.props.redirect();
                        }

                        if ( ref.data.user.phone === '' || ref.data.user.address === ''
                            || ref.data.user.city === '' || ref.data.user.district === '' || ref.data.user.ward === ''
                        )
                        {
                            this.props.redirectUpdateInfo();
                        }
                        else
                        {
                            this.props.updateInfo({
                                updateInfo: true,
                            })
                        }

                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            btnDisable: false,
                            isLoading: false
                        })
                    }

                })
                .catch( () => {
                    // console.log(error);
                    this.setState({
                        error: true,
                        messageError: 'Đăng nhập thất bại',
                        isLoading: false,
                        btnDisable: false
                    })
                })
        }
    }

    validate = () => {
        if ( this.state.email.length === 0 || this.state.password.length === 0 ) {
            this.setState({
                error: true,
                messageError: 'Email hoặc mật khẩu không được để trống',
                btnDisable: false
            })
            return false;
        }
        return true;
    }

    changeInput(event) {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <>
                {
                    this.state.isLoading ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <Row
                            style={{
                                height: '100vh',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Col md={6} lg={4} className="m-3">
                                <Card body>
                                    <Form onSubmit={() => this.submitLogin()}>
                                        <div className="text-center pb-3">
                                            <img
                                                src={ this.props.config.website_logo }
                                                className="rounded"
                                                style={{ width: 90, height: "auto", cursor: 'pointer' }}
                                                alt="logo"
                                            />
                                            <h4 className="text-primary mt-2">{ this.props.config.website_company ? this.props.config.website_company : '' }</h4>
                                        </div>
                                        {
                                            this.state.error ? (

                                                <Alert color="danger">
                                                    <div className='text-center'>
                                                        { this.state.messageError }
                                                    </div>
                                                </Alert>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        {
                                            this.state.errorNotification ? (

                                                <Alert color="danger">
                                                    <div className='text-center'>
                                                        { this.state.messageErrorNotification }
                                                    </div>
                                                </Alert>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        {
                                            this.state.successNotification ? (

                                                <Alert color="success">
                                                    <div className='text-center'>
                                                        { this.state.messageSuccessNotification }
                                                    </div>
                                                </Alert>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        <FormGroup>
                                            <Label for={'Email'}>{'Email'}</Label>
                                            <Input type="email" placeholder="Email" name="email"  onChange={this.changeInput} value={this.state.email} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for={'Password'}>{'Password'}</Label>
                                            <Input type="password" placeholder="Password" name="password"  onChange={this.changeInput} value={this.state.password} />
                                        </FormGroup>
                                        <FormGroup check>
                                            <Label check>
                                                <Input type="checkbox" name="remember" onChange={this.changeInput} value="1" checked={this.state.remember} /> Remember me
                                            </Label>
                                        </FormGroup>
                                        <hr />
                                        <Button
                                            size="lg"
                                            className="bg-gradient-theme-left border-0"
                                            block
                                            onClick={() => this.submitLogin()}
                                            disabled={ this.state.btnDisable }
                                        >
                                            Đăng nhập
                                        </Button>
                                    </Form>
                                    <div className="text-center pt-1 mt-2">
                                        <h6>hoặc</h6>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-6">
                                            <h6>
                                                <Link to="/tao-tai-khoan.html">Tạo tài khoản</Link>
                                            </h6>
                                        </div>
                                        <div className="col-6 text-right">
                                            <h6>
                                                <Link to="/quen-mat-khau.html">Quên mật khẩu?</Link>
                                            </h6>
                                        </div>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    )
                }
            </>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        config: state.configSystem.config,
        errorNotificationUser: state.notificationUser.errorNotificationUser,
        messageErrorNotificationUser: state.notificationUser.messageErrorNotificationUser,
        successNotificationUser: state.notificationUser.successNotificationUser,
        messageSuccessNotificationUser: state.notificationUser.messageSuccessNotificationUser,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        remember: (item) => {
            dispatch(({ type : 'remember', item }))
        },
        login: (item) => {
            dispatch(({ type : 'login', item }))
        },
        saveUser: (item) => {
            dispatch(({ type : 'saveUser', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
        updateSystem: (item) => {
            dispatch(({ type : 'updateSystem', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
        updateAgencyCredit: (item) => {
            dispatch(({ type : 'updateAgencyCredit', item }))
        },
        updatePageAdmin: (item) => {
            dispatch(({ type : 'updatePageAdmin', item }))
        },
        updateInfo: (item) => {
            dispatch(({ type : 'updateInfo', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginComponent);
